<template>
  <el-tooltip content="Tasks" placement="bottom">
    <el-button circle style="width: 35px; height: 35px" @click="navigateTasks">
      <fa-icon :icon="faClipboardCheck" class="text-[18px]" />
    </el-button>
  </el-tooltip>
</template>

<script>
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'Tasks',
  setup() {
    const router = useRouter()
    const route = useRoute()

    const navigateTasks = () => {
      router.push({ name: route.meta.type + `/task-queue` })
    }
    return {
      faClipboardCheck,
      navigateTasks,
    }
  },
}
</script>
